import React from 'react';
import { createGlobalStyle } from 'styled-components';
import { DropDownGlobalStyle } from '@components/dropdowns';
import { DateTimePickerGlobalStyles } from '@components/date';

const Styles = createGlobalStyle`
    ::-webkit-scrollbar {
        width: 4px;
        height: 4px;
    }

    .scrollbar-bigger,
    .ace_scrollbar {
        &::-webkit-scrollbar {
            width: 8px;
            height: 8px;
        }

        &::-webkit-scrollbar-track {
            //background-color: #fff;
        }
    }

    ::-webkit-scrollbar-track {
        -webkit-box-shadow: none;
    }

    ::-webkit-scrollbar-thumb {
        border-radius: 3px;
        background-color: ${(props) => props.theme.colors.road_grey_200};
    }

    .react-app-route .z2-state-loading:not(.react-loader) {
        display: none;
    }

    body:not(.kendo-ng), body.kendo-ng {
        .k-animation-container-shown {
            background: transparent;
            box-shadow: none;
        }

        .k-animation-container {
            z-index: 100;

            &.autocomplete-popup .k-popup > div {
                max-height: 220px;
                height: auto !important;
            }
        }

        .k-animation-container > .k-popup {
            background: #fff !important;
            box-shadow: 0 1px 4px rgba(86, 99, 122, 0.2);
            border-radius: 4px;
            padding: 0;
            min-width: 140px;
            border: 0 !important;

            > div:not(:empty) {
                padding: 10px 0;
            }

            .k-menu-group .k-menu-link {
                padding: 0 !important;
                margin: 0 !important;
                flex-direction: column !important;
                align-items: baseline !important;

                .k-icon {
                    display: none !important;
                }
            }

            .k-item, .k-list-item {
                box-shadow: none;
                border: none;
                line-height: 1.8em;
                min-height: 1.8em;

                &.k-selected {
                    color: ${(props) => props.theme.colors.brand_primary_blue}
                }

                .autocomplete-item-hint {
                    font-size: 12px;
                    padding-right: 5px;
                    color: ${(props) => props.theme.colors.road_grey_600};
                }
            }
        }

        .k-list-scroller {
            &::-webkit-scrollbar {
                width: 4px;
                height: 4px;
            }

            &.scrollbar-bigger {
                &::-webkit-scrollbar {
                    width: 8px;
                    height: 8px;
                }

                &::-webkit-scrollbar-track {
                    //background-color: #fff;
                }
            }

            &::-webkit-scrollbar-track {
                -webkit-box-shadow: none;
            }

            &::-webkit-scrollbar-thumb {
                border-radius: 3px;
                background-color: #7fc0e0;
            }
        }

        .scrollbar,
        .autocomplete-popup .k-popup > div,
        .edit-page-tabs .k-tabstrip .k-content,
        .edit-page-tabs .json-field .json-schema-manager-wrapper,
        .form-script-editor .ace_scrollbar,
        .k-panelbar-header > .k-animation-container {
            &::-webkit-scrollbar {
                width: 4px;
                height: 4px;
            }

            &.scrollbar-bigger,
            &.k-content,
            &.ace_scrollbar {
                &::-webkit-scrollbar {
                    width: 8px;
                    height: 8px;
                }

                &::-webkit-scrollbar-track {
                    //background-color: #fff;
                }
            }

            &::-webkit-scrollbar-track {
                -webkit-box-shadow: none;
            }

            &::-webkit-scrollbar-thumb {
                border-radius: 3px;
                background-color: ${(props) => props.theme.colors.road_grey_200};
            }
        }
    }
`;

export const GlobalStyle = () => (
    <>
        <Styles />
        <DropDownGlobalStyle />
        <DateTimePickerGlobalStyles />
    </>
);
